import { request } from '@/plugins/http';

/**
 * 车型列表
 * @param params
 * @returns {AxiosPromise}
 */
const getDatavehicleTypePage = params => request('/vehicleType/getDatavehicleTypePage', params);

/**
 * 新增车型
 * @param params
 * @returns {AxiosPromise}
 */
const addDatavehicleType = params => request('/vehicleType/addDatavehicleType', params);

/**
 * 修改车型
 * @param params
 * @returns {AxiosPromise}
 */
const updateDatavehicleType = params => request('/vehicleType/updateDatavehicleType', params);

/**
 * 获取全部车型
 * @param params
 * @returns {AxiosPromise}
 */
const getDatavehicleTypeList = params => request('/vehicleType/getDatavehicleTypeList', params);

/**
 * 获取全部车型
 * @param params
 * @returns {AxiosPromise}
 */
const delDatavehicleTypes = params => request('/vehicleType/delDatavehicleTypes', params);


export {
    getDatavehicleTypePage,
    addDatavehicleType,
    updateDatavehicleType,
    getDatavehicleTypeList,
    delDatavehicleTypes,
};
